import { API_URL } from 'shared/constants'
import Fetcher from 'shared/lib/fetcher/fetcher'
import { isUserLoggedIn } from 'shared/lib/user'
import { getUserTimeZone } from 'shared/utils'

export const fetcherClient = new Fetcher(API_URL)

fetcherClient.requestMiddleware((e, url) => {
  const token = isUserLoggedIn()
  e.headers.authorization = token
  e.headers['x-timezone'] = getUserTimeZone()
  e.headers['x-platform'] = 'web'
  e.headers['x-sLang'] = 'en'
  // e.headers['x-iVenueId'] = _id
  return e
})

fetcherClient.responseMiddleware((e, url) => {
  if (e.status === 401) {
    // userLogOut()
    console.log(e)
    // window.location = `/?from=${location.pathname}${location.search || ''}`
  }
  return e
})
